import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/audition.png';

// High-tech Casting & Audition Icons
import TheaterComedyRoundedIcon from '@mui/icons-material/TheaterComedyRounded';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import VideoCameraFrontRoundedIcon from '@mui/icons-material/VideoCameraFrontRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';

const AuditionsIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Auditions"
      subtitle="Verified Film, TV & Commercial Casting Calls"
      desc="Directly audition for leading and supporting roles in major feature films, television pilots, streaming series, and global commercials. Submit video showreels and get booked with zero agency middleman fees."
      image={image}
      themeColor="#f43f5e"
      bgGradient="linear-gradient(135deg, rgba(244,63,94,0.2) 0%, rgba(244,63,94,0.02) 100%)"
      marqueeItems={[
        { icon: '🎭', tag: 'CASTING', text: 'Universal Pictures posted 4 Lead Roles for upcoming Sci-Fi Feature', time: '2m ago', color: '#f43f5e' },
        { icon: '🎬', tag: 'CALLBACK', text: 'Elena Rostova secured Director Callback for "Echoes of Rome"', time: '5m ago', color: '#10b981' },
        { icon: '🤖', tag: 'AI MATCH', text: 'Voice Actor match algorithm paired 18 narrators to Netflix documentary', time: '8m ago', color: '#07a4f5' },
        { icon: '⭐', tag: 'SAG VERIFIED', text: 'Studio Canal verified SAG-AFTRA tier-1 production casting notice', time: '12m ago', color: '#f59e0b' },
        { icon: '📹', tag: 'SHOWREEL', text: '4K self-tape audition reel delivered in pristine ProRes to Tokyo', time: '17m ago', color: '#8b5cf6' },
        { icon: '💰', tag: 'CONTRACT', text: 'Smart contract escrow disbursed advance casting stipend to lead actor', time: '21m ago', color: '#ec4899' },
      ]}
      features={[
        {
          id: 'showreels',
          icon: <RecordVoiceOverRoundedIcon sx={{ fontSize: 26 }} />,
          title: '1-Tap Video Showreel Submissions',
          desc: 'Submit multi-angle 4K showreels, voice stems, and verified headshots directly to Hollywood and indie casting panels.',
          badge: '1-Tap Submit',
          metric: '4K HDR Showreels',
          highlight: 'Zero Transcode Delay',
          hasEqualizer: true,
        },
        {
          id: 'sag-roles',
          icon: <TheaterComedyRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Verified SAG-AFTRA & Indie Roles',
          desc: 'Access verified casting notices for feature films, web series, commercials, and theatrical performances with transparent pay rates.',
          badge: 'Verified Roles',
          metric: '850+ Active Calls',
          highlight: 'SAG-AFTRA Ready',
          hasPulse: true,
        },
        {
          id: 'ai-matching',
          icon: <AutoAwesomeRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Neural AI Character Matching',
          desc: 'Intelligent AI analyzes screenplay character specs, vocal timbre, and performance styles to match ideal talent automatically.',
          badge: 'Neural Match',
          metric: '98.4% Match Rate',
          highlight: 'Automated Tokenizer',
        },
        {
          id: 'virtual-room',
          icon: <VideoCameraFrontRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Live Virtual Audition Stage',
          desc: 'Ultra-low latency virtual casting rooms with synchronized script teleprompter, director mark notes, and multi-actor chemistry reads.',
          badge: 'Live Room',
          metric: '< 18ms Latency',
          highlight: 'Script Teleprompter',
        },
        {
          id: 'callbacks',
          icon: <NotificationsActiveRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Instant Callback HUD',
          desc: 'Real-time push alerts, instant script side releases, and automated schedule bookings directly with casting directors.',
          badge: 'Instant Alerts',
          metric: '< 2h Average Reply',
          highlight: 'Direct Message',
        },
        {
          id: 'contracts',
          icon: <MonetizationOnRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Digital Contract & Escrow Pay',
          desc: 'Automated standard union casting contracts with guaranteed escrow deposits and instant royalties straight to your account.',
          badge: 'Smart Escrow',
          metric: 'Zero Agent Cuts',
          highlight: 'Instant Payout',
        },
      ]}
    />
  );
};

export default AuditionsIndustry;
